// Luxury mini-pictograms for the STYLE ↔ HOME selector.
// Dimensional, editorial silhouettes that inherit currentColor for active/inactive states.

export const StyleGlyph = ({ size = 14, className = "" }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} aria-hidden="true">
    {/* tailor's dress-form bust — instantly reads as fashion */}
    <path
      d="M9.3 4.6c.32-1 1.2-1.6 2.7-1.6s2.38.6 2.7 1.6c.36 1.12 1.16 1.74 2.06 2.32.68.44 1.04 1 1.04 1.78 0 .62-.4 1.02-1 1.14l-1.18.24c.26 1.42.62 2.94 1.02 4.26.3 1-.32 1.86-1.4 1.86H8.76c-1.08 0-1.7-.86-1.4-1.86.4-1.32.76-2.84 1.02-4.26l-1.18-.24c-.6-.12-1-.52-1-1.14 0-.78.36-1.34 1.04-1.78.9-.58 1.7-1.2 2.06-2.32Z"
      fill="currentColor"
    />
    {/* centre seam for dimension */}
    <path d="M12 8.4v6.2" stroke="currentColor" strokeOpacity="0.35" strokeWidth="0.9" strokeLinecap="round" />
    {/* stand */}
    <path d="M12 16.6v2.7M9.4 20h5.2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const HomeGlyph = ({ size = 14, className = "" }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} aria-hidden="true">
    {/* mid-century lounge chair in profile — editorial interior symbol */}
    <path
      d="M6.9 5.2c.06-1.05.9-1.75 1.86-1.63.9.11 1.5.86 1.6 1.86l.42 4.29h4.5c1.28 0 2.26 1.12 2.12 2.39l-.36 3.24c-.07.62-.6 1.06-1.22 1.06H8.06c-.62 0-1.15-.46-1.2-1.08L6.9 5.2Z"
      fill="currentColor"
    />
    {/* seat cushion seam */}
    <path d="M10.4 11.7h6.1" stroke="currentColor" strokeOpacity="0.32" strokeWidth="0.9" strokeLinecap="round" />
    {/* legs */}
    <path d="M8 16.4 7.1 19.4M16.6 16.4l.9 3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);
